/* eslint-disable */
import vxxData from '../kits/data.js'
import { Dialog, Toast } from 'vant'
import GLOBAL_CONFIG from '../../global/index'

import axios from 'axios'
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

export default {
  getQueryString,
  getQueryString2,
  baseUrl,
  baseUrl2,
  baseUrl3,
  baseUrl4,
  tencentOssUrl,
  tencnetConfigOssUrl,
  userOSSConfigUrl,
  baseUrlUser,
  baseUrlUserBak,
  onlineBaseURL,
  getTestSchoolApi,
  getShanHuHyLiveApi,
  changeTime,
  setCookie,
  getCookie,
  delCookie,
  two,
  isWeixin,
  isWeChat,
  login,
  logout,
  emotion,
  pcWXLogin,
  getFakeLiveInfo,
  mergeDsData,
  getQueryData,
  getUrlAddQuery,
  getUserInfoByToken,
  baseUrlSchool,
  getUserInfoReloadByToken,
  guid,
  isIPad,
  isTablet,
  setDsId,
  setBuinessId,
  setOrgConfig
}

let app_Id = null
let fans = {}
let orgConfig = {}
var agreement = 'https://'
var developer = false

if (process.env.BUILD_ENV == 'production') {
  developer = false;
  agreement = 'https://'
  console.log = function() {}
} else {
  console.log("当前在测试环境");
  developer = false;
}
// developer = false;
//   agreement = 'https://'
export const payOpenClassHost = () => {
  // 付费公开课测试域名
  let host = agreement + 'live.tenghuiketang.com'
  if (!developer) {
    // 付费公开课生产域名
    // host = agreement + 'live.shkt.online'
    host = `${Vue.prototype.SHANHU_LIVE_API}`
  }
  return host
}

function setOrgConfig(config) {
  orgConfig = config
}

function baseUrl () {
	var baseUrl;
	if (developer) {
		baseUrl = agreement + "liveapi.tenghuiwangxiao.cn";
	} else {
		baseUrl = agreement + "liveapi.tenghuiwangxiao.cn";
	}
	return baseUrl;
}

function baseUrl2 () {
	if(developer){
		return agreement + "live.tenghuiketang.com/liveapi";
	}else{
		// return agreement + "live.shkt.online/liveapi";
    return `${Vue.prototype.SHANHU_LIVE_API}/liveapi`
	}
}

function baseUrl3 () {
	if(developer){
		return agreement + "live.tenghuiketang.com/liveapi/wap";
	}else{
		// return agreement + "live.shkt.online/liveapi/wap";
    return `${Vue.prototype.SHANHU_LIVE_API}/wap`
	}
}

function baseUrl4 () {
	if(developer){
		return agreement + "live.tenghuiketang.com/liveapi/api";
	}else{
		// return agreement + "live.shkt.online/liveapi/api";
    return `${Vue.prototype.SHANHU_LIVE_API}/liveapi/api`
	}
}

function baseUrlUser () {
	if(developer){
		return  agreement + "data.tenghuiketang.com/dataapi";
	}else{
		// return  agreement + "data.shkt.online/dataapi";
    return `${Vue.prototype.SHANHU_DATA_API}/dataapi`
	}
}

function baseUrlUserBak () {
	if(developer){
		return  agreement + "data.tenghuiketang.com/dataapi";
	}else{
		// return  agreement + "data.shkt.online/dataapi";
    return `${Vue.prototype.SHANHU_DATA_API}/dataapi`
	}
}

function baseUrlSchool () {
	if(developer){
		return  agreement + "online.tenghuiketang.com/onlineapi";
	}else{
		// return  agreement + "school.shkt.online/onlineapi";
    return `${Vue.prototype.SHANHU_ONLINE_API}/onlineapi`
	}
}
function onlineBaseURL() {
  if(developer){
		return  agreement + "online.tenghuiketang.com";
	}else{
		// return  agreement + "school.shkt.online";
    return `${Vue.prototype.SHANHU_ONLINE_API}`
	}
}

function getTestSchoolApi() {
  if (developer) {
    return agreement + "test-school.tenghuiketang.com";
  }
  return `${Vue.prototype.SHANHU_ONLINE_HY_API}`
}

function getShanHuHyLiveApi() {
  if (developer) {
    return agreement + "test-live.tenghuiketang.com";
  }
  return `${Vue.prototype.SHANHU_LIVE_HY_API}`
}


function tencentOssUrl() {
  if(developer){
		return "";
	}else{
		// return 'https://tengface-live-user-1308721187.cos.ap-guangzhou.myqcloud.com'
    return GLOBAL_CONFIG.platformLiveChannelCacheDomain
	}
}

function tencnetConfigOssUrl() {
  if(developer){
		return "https://shkt-online-live-1317978474.cos.ap-nanjing.myqcloud.com";
	}else{
		// return  'https://shkt-online-live-1317978474.cos.ap-nanjing.myqcloud.com'
    return GLOBAL_CONFIG.platformDefaultConfigDomain
	}
}

function userOSSConfigUrl() {
  if(developer){
		return "";
	}else{
		return 'https://tengface-live-user.oss-cn-shenzhen.aliyuncs.com'
	}

}

function getQueryString (name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

function getQueryString2 (urlStr, name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  if (urlStr.indexOf('?') != -1) {
    urlStr = '?' + urlStr.substr(urlStr.indexOf('?') + 1)
    var r = urlStr.substr(1).match(reg)
    if (r != null) return unescape(r[2])
  }
  return null
}

function setCookie (name, value, Days) {
  var exp = new Date()
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
  document.cookie =
    name + '=' + escape(value) + ';expires=' + exp.toGMTString() + ';path=/'
}
function getCookie (name) {
  var arr,
    reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  return (arr = document.cookie.match(reg)) ? unescape(arr[2]) : null
}
function delCookie (name) {
  setCookie(name, 0, -1)
  //     var exp = new Date();
  //     exp.setTime(exp.getTime() - 1);
  //     var cval=getCookie(name);
  //     if(cval!=null)
  //         document.cookie= name + "="+cval+";expires="+exp.toGMTString();
}

function changeTime (time) {
  var h = parseInt(time / 3600)
  var m = parseInt((time % 3600) / 60)
  var s = parseInt(time % 60)
  return two(h) + ':' + two(m) + ':' + two(s)
}

function two (num) {
  if (num < 10) {
    return '0' + num
  }
  return num
}

function isWeixin () {
  var agent = navigator.userAgent.toLowerCase()
  if (agent.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}

var ds_id = getQueryString('ds_id')
function setDsId(dsId) {
  ds_id = dsId
}

var business_id = ''
function setBuinessId(buinessId) {
  business_id = buinessId
}



function initwxLogin (callback) {
  // 获取微信参数
  var loginCode = getQueryString('code')
  var loginState = getQueryString('state')
  if (loginCode) {
    var loginUrl = baseUrl2() + '/wxpclogin'
    var option =
      'code=' + loginCode + '&state=' + loginState + '&ds_id=' + ds_id
    axios
      .post(loginUrl, option)
      .then(function (data) {
        var data = data.data
        if (data.code == '200') {
          console.log(data.data)
          var obj = JSON.stringify(data.data)
          setCookie('userInfo', obj, 30)
          setCookie('token', data.data.token, 30)
          callback(data.data)
          console.log('登录成功')
        } else {
          window.location.href =
            'http://u.shanghuketang.cn/PClive/?ds_id=' + ds_id
        }
      })
      .catch(function (data) {
        console.log(data.message)
      })
  } else {
    var fans = { fans_id: 1 }
    callback(fans)
  }
}

function pcWXLogin (appid, ds_id, callback, title) {
  app_Id = appid
  var loginCode = getQueryString('code')
  if (!loginCode) {
    // 不存在,获取code
    initLoginJumpWx(app_Id, '', title)
  } else {
    let loginType = getQueryString("loginType");
    if (loginType == "cloudapi") {
        getFansInfoCloudApi(liveapp_uid,callback)
    }else{
      getFansInfo(loginCode, ds_id, callback)
    }

  }
}

function getFansInfoCloudApi(liveapp_uid,callback) {
  var loginUrl = "https://service-jmibg8h4-1317978474.gz.apigw.tencentcs.com/release/getUserInfo";
  console.log(loginUrl);
    axios.post(loginUrl,{code:loginCode},{timeout: 5000}).then(function(data) {
        console.log("getFansInfoCloudApi====>",data)
        if (data.data.code == 200) {
          var data = data.data.data;
          console.log("getFansInfoCloudApi2====>",data)
          registerUserInfo(liveapp_uid,data,callback)
        }else if (data.data.code == 400) {
          initLoginJumpWx(app_Id,'cloudapi');
        }
      }).catch(function(data) {
        // Toast("网络错误！");
        console.log("网络错误！",data)
        // console.log(JSON.stringify(data));
        let fansInfoTMp = getCacheUserInfo(app_Id)
        if (fansInfoTMp) {//用缓存用户信息
          callback(fansInfoTMp);
        }else { //随机用户信息
         let fansIdTmp = createCode();
         let fans = {
            fans_id: fansIdTmp,
            header: "https://tengface-live.oss-cn-beijing.aliyuncs.com/admin/img/youke_header.png",
            nick: `用户_${fansIdTmp}`,
            userSig: "",
            token:"",
            unReal:1
          };
          //适配其他的应用
          callback(fans);
        }
      });
}

//注册用户信息
function registerUserInfo(liveapp_uid,userInfo,callBack) {

  let params = `nick=${userInfo.nickname}&uid=${liveapp_uid}&openid=${userInfo.openid}&header=${userInfo.headimgurl}`
  axios.post(baseUrl2()+"/user/login/register",params)
  .then(function(response) {
    if(response.data.code == 200){
      var data = response.data.data;
        fans = {
          fans_id: data.fans_id,
          header: data.header,
          nick: data.nick,
          userSig: data.tsl_sig,
          real_auth: data.real_auth,
          status: data.status,
          token: data.token
        };
        //适配其他的应用
        if (app_Id) {
          localStorage.setItem(app_Id, JSON.stringify(fans))
        }
        callBack(fans);
    }else{
        fans = {
          fans_id: userInfo.fans_id,
          header: userInfo.headimgurl,
          nick: userInfo.nickname,
          userSig: userInfo.tsl_sig,
          real_auth: userInfo.real_auth,
          status: userInfo.status,
          token: userInfo.token,
          unReal:1
        };
        //适配其他的应用
        if (app_Id) {
          localStorage.setItem(app_Id, JSON.stringify(fans))
        }
        callBack(fans);
    }
  })
  .catch(function(error) {
    //这里需要缓存数据,然后重新加载
       let fans = {
          fans_id: userInfo.fans_id,
          header: userInfo.headimgurl,
          nick: userInfo.nickname,
          userSig: userInfo.tsl_sig,
          real_auth: userInfo.real_auth,
          status: userInfo.status,
          token: userInfo.token,
          unReal:1
        };
        //适配其他的应用
        if (app_Id) {
          localStorage.setItem(app_Id, JSON.stringify(fans))
        }
        callBack(fans);
  });
}

function mergeDsData (fakeInfo, dsInfo) {
  var newInfo = {...dsInfo}
  newInfo.direct_seeding.room_id = fakeInfo.room_id
  newInfo.direct_seeding.name = fakeInfo.name
  newInfo.direct_seeding.real_start_time = fakeInfo.start_time_real
  newInfo.direct_seeding.real_end_time = fakeInfo.end_time_real
  newInfo.fakeLive = true
  newInfo.fakeTemplateId = fakeInfo.t_id
  newInfo.direct_seeding.break_point = []
  if (fakeInfo.status == '1') {
    newInfo.direct_seeding.direct_status = 'not_started'
    newInfo.box_info = {}
  } else if (fakeInfo.status == '2') {
    newInfo.direct_seeding.direct_status = 'running'
    newInfo.box_info = {
      pull_stream_url: JSON.stringify({
        flv_url: fakeInfo.play_url_flv,
        m3u8_url: fakeInfo.play_url_m3u8,
        play_url_web_rtc: fakeInfo.play_url_web_rtc
      })
    }
  } else if (fakeInfo.status == '3') {
    newInfo.direct_seeding.direct_status = 'end'
    newInfo.box_info = {}
  }

  return newInfo
}

// 获取伪直播信息
function getFakeLiveInfo (tid, callback) {
  axios
    .post(baseUrl3() + '/live/getLiveInfoById', 'tid=' + tid)
    .then(function (response) {
      if (response.data.code === 200) {
        callback(true, response.data.data)
      } else {
        callback(false, response)
      }
    })
    .catch(function (error) {
      callback(false, error)
    })
}

// 获取动态参数
function getFansInfo (loginCode, ds_id, callback) {
  var loginUrl =
    baseUrl2() + '/api/user/login/autoLogin/?code=' + loginCode + '&ds_id=' + ds_id
  axios
    .get(loginUrl)
    .then(function (data) {
      if (data.data.code == 200) {
        var data = data.data.data
        // 这里需要缓存数据,然后重新加载
        fans = {
          fans_id: data.fans_id,
          header: data.header,
          nick: data.nick,
          userSig: data.tsl_sig,
          real_auth: data.real_auth,
          status: data.status,
          token: data.token
        }
        if (app_Id) {
          localStorage.setItem(app_Id, JSON.stringify(fans))
        }
        callback(fans)
      } else if (data.data.code == 400) {
        initLoginJumpWx(app_Id)
      }
    })
    .catch(function (data) {
      console.log('登陆失败', data)
      initLoginJumpWx(app_Id,'cloudapi');
    })
}

// 用token获取用户信息
function getUserInfoByToken () {
  var token = getQueryString('token')
  var otherLogin = getQueryString('other')
  var netschool_token = getQueryString('shool_token')
  //  测试环境也可以 和  iOS safair浏览器下有效 而且不在微信环境
  if (token) {
    if ((isIhponeSafari() && !isWeixin()) || otherLogin) {
       if (netschool_token) {
         setCookie('netschool_token',netschool_token, 30)
       }
      const user = { token }
      localStorage.setItem(app_Id, JSON.stringify(user))
      axios.post(baseUrl2() + '/api/user/getUserInfoByToken', 'token='+token).then((res) => {
        if (res.data.code == 200) {
          var userInfo = res.data.data
          console.log('[<-- userInfo -->]',userInfo);
          fans = {
            fans_id: userInfo.fans_id,
            header: userInfo.header,
            nick: userInfo.nick,
            userSig: userInfo.tsl_sig,
            real_auth: userInfo.real_auth,
            status: userInfo.status,
            token: userInfo.token,
            stu_note:userInfo.stu_note
          }
          // 适配其他的应用
          setCookie('userInfo', JSON.stringify(fans), 30)
          setCookie('token', fans.token, 30)
          setCookie('fans_id', fans.fans_id)
          if (app_Id) {
            localStorage.setItem(app_Id, JSON.stringify(fans))
          }
        }
        clearToken()
      }).catch((error) => {
        console.error('getUserInfoByToken', error)
        clearToken()
      })
    }
  }
}

// 获取到了token更新用户信息
function getUserInfoReloadByToken(token){
  if(token){
    const user = { token };
    setCookie('token', token, 30)
    localStorage.setItem(app_Id,JSON.stringify(user));
    axios.post(baseUrl4() + "/user/getUserInfoByToken").then((res)=>{
      if(res.data.code == 200){
        var userInfo = res.data.data;
        fans = {
          fans_id: userInfo.fans_id,
          header: userInfo.header,
          nick: userInfo.nick,
          userSig: userInfo.tsl_sig,
          real_auth: userInfo.real_auth,
          status: userInfo.status,
          token: userInfo.token,
        };
        //适配其他的应用
        setCookie('userInfo', JSON.stringify(fans), 30)
        setCookie('token', userInfo.token, 30)
        setCookie('fans_id', userInfo.fans_id)
        if (app_Id) {
          localStorage.setItem(app_Id, JSON.stringify(fans));
        }
        window.location.reload();
      }
    }).catch((error)=>{
      console.error("getUserInfoByToken",error);
    });
  }else{
    console.error("getUserInfoReloadByToken","token不存在");
  }
}

function initLoginJumpWx (appid,loginType, liveTitle) {
  // var redirect_uri = window.location.href
  // redirect_uri = redirect_uri.split('&code')[0]
  // if (loginType == "cloudapi" && redirect_uri.indexOf("loginType") == -1) {
  //   redirect_uri = redirect_uri + "&loginType=cloudapi"
  // }
  // window.location.href =
  //   'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' +
  //   appid +
  //   '&redirect_uri=' +
  //   encodeURIComponent(redirect_uri) +
  //   '&response_type=code&scope=snsapi_userinfo&state=STATE'
  var redirect_uri = window.location.href;
  redirect_uri = redirect_uri.split("&code")[0];
  if (loginType == "cloudapi" && redirect_uri.indexOf("loginType") == -1) {   
    redirect_uri = redirect_uri + "&loginType=cloudapi"
  }
  const redirectUrl =  encodeURIComponent(redirect_uri)
  // window.location.href = `https://autha.coralclass.cn/login/#/wx-login?appId=${appid}&ds_id=${ds_id}&uId=${business_id || ''}&redirectUrl=${redirectUrl}&title=授权登录&origin=shanhu`
  window.location.href = `${orgConfig.wechat_auth_domain}/login/#/wx-login?appId=${orgConfig.official_account_appid}&ds_id=${ds_id}&uId=${business_id || ''}&redirectUrl=${redirectUrl}&title=授权登录&origin=shanhu`
}

function login (callback) {
  var test = getCookie('userInfo')
  //	console.log("userInfo:" + test);
  if (test && test != 'undefined') {
    test = JSON.parse(test)
    callback(test)
    console.log('a')
  } else {
    initwxLogin(callback)
    console.log('b')
  }
}
function logout () {
  // setCookie('userInfo', '', 30);
  delCookie('userInfo')
  delCookie('token')
  setTimeout(() => {
    window.location.reload()
  }, 100);
}

function isIhponeSafari () {
  var ua = navigator.userAgent.toLowerCase()
  // 判断是不是在iPhone的Safair浏览器打开的本页面
  if (ua.indexOf('applewebkit') > -1 && ua.indexOf('mobile') > -1 && ua.indexOf('safari') > -1 &&
      ua.indexOf('linux') === -1 && ua.indexOf('android') === -1 && ua.indexOf('chrome') === -1 &&
      ua.indexOf('ios') === -1 && ua.indexOf('browser') === -1) {
    console.log('是safari')
    return true
  } else {
    console.log('不是safari')
    return false
  }
}

function isIPad() {
  var userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf('ipad') !== -1;
}

function getQueryData (url) {
  var urlAll = url
  var tmp = urlAll.split('#')[0]
  tmp = tmp.split('?')
  if (tmp.length == 1) {
    return {}
  }
  var list = tmp[1].split('&')
  console.log(list)
  var data = {}
  for (let index = 0; index < list.length; index++) {
    var element = list[index]
    var arr = element.split('=')
    if (arr.length >= 2) {
      data[arr[0]] = element.substring(arr[0].length + 1)
    }
  }
  return data
}

function getUrlAddQuery (url, data) {
  var isFrist = true
  for (const key in data) {
    var value = data[key]
    if (value === '') {
      continue
    }
    if (isFrist) {
      isFrist = false
      url = url + '?'
      url = url + key + '=' + value
    } else {
      url = url + '&' + key + '=' + value
    }
  }
  return url
}

function clearToken () {
  var data = getQueryData(window.location.href)
  data.token = ''
  data.shool_token = ''
  var url = getUrlAddQuery(window.location.protocol + '//' + window.location.host + '/', data)
  window.location.href = url
}

function emotion (res) {
  let word = res.replace(/\#|\;/gi, '')
  const list = [
    '微笑',
    '撇嘴',
    '色',
    '发呆',
    '得意',
    '流泪',
    '害羞',
    '闭嘴',
    '睡',
    '大哭',
    '尴尬',
    '发怒',
    '调皮',
    '呲牙',
    '惊讶',
    '难过',
    '酷',
    '冷汗',
    '抓狂',
    '吐',
    '偷笑',
    '可爱',
    '白眼',
    '傲慢',
    '饥饿',
    '困',
    '惊恐',
    '流汗',
    '憨笑',
    '大兵',
    '奋斗',
    '咒骂',
    '疑问',
    '嘘',
    '晕',
    '折磨',
    '衰',
    '骷髅',
    '敲打',
    '再见',
    '擦汗',
    '抠鼻',
    '鼓掌',
    '糗大了',
    '坏笑',
    '左哼哼',
    '右哼哼',
    '哈欠',
    '鄙视',
    '委屈',
    '快哭了',
    '阴险',
    '亲亲',
    '吓',
    '可怜',
    '菜刀',
    '西瓜',
    '啤酒',
    '篮球',
    '乒乓',
    '咖啡',
    '饭',
    '猪头',
    '玫瑰',
    '凋谢',
    '示爱',
    '爱心',
    '心碎',
    '蛋糕',
    '闪电',
    '炸弹',
    '刀',
    '足球',
    '瓢虫',
    '便便',
    '月亮',
    '太阳',
    '礼物',
    '拥抱',
    '强',
    '弱',
    '握手',
    '胜利',
    '抱拳',
    '勾引',
    '拳头',
    '差劲',
    '爱你',
    'NO',
    'OK',
    '爱情',
    '飞吻',
    '跳跳',
    '发抖',
    '怄火',
    '转圈',
    '磕头',
    '回头',
    '跳绳',
    '挥手',
    '激动',
    '街舞',
    '献吻',
    '左太极',
    '右太极'
  ]
  let index = list.indexOf(word)
  return (
    '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/' +
    index +
    '.gif" align="middle">'
  )
}

function isWeChat () {
  var ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    var system = {
      win: false,
      mac: false
    }
    // 检测平台
    var p = navigator.platform
    system.win = p.indexOf('Win') == 0
    system.mac = p.indexOf('Mac') == 0
    if (system.win || system.mac) {
      alert('在微信PC端上打开内置浏览器')
    } else {
      alert('非微信PC端上打开内置浏览器')
    }
  }
}

function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
  });
}

/**
 * 描述：判断当前环境是否为平板
**/
function isTablet() {
  var userAgentInfo = navigator.userAgent;
  // 根据不同的平台进行判断
  if (/Android/.test(userAgentInfo) && /Mobile|iPad/i.test(userAgentInfo)) {
      return false;
  } else if (/(Windows Phone)/i.test(userAgentInfo)) {
      return false;
  } else if (/Macintosh/.test(userAgentInfo) && !/(Safari)/i.test(userAgentInfo)) {
      return true;
  } else if ((/Intel Mac OS X/).test(userAgentInfo) || (/AppleWebKit.*Mobile/).test(userAgentInfo)) {
      return true;
  } else if (/MIDP/.test(userAgentInfo) || /SymbianOS/.test(userAgentInfo)) {
      return true;
  } else if (/Opera Mini/.test(userAgentInfo)) {
      return true;
  } else if (/IEMobile/.test(userAgentInfo)) {
      return false;
  } else {
      return false;
  }
}



// WEBPACK FOOTER //
// ./src/kits/Tools.js